export enum UserType {
    LOGGED_IN = 'LOGGED_IN',
    NOT_LOGGED_IN = 'NOT_LOGGED_IN',
}
export enum Action {
    ACCEPTED = 'ACCEPTED',
    WITHDRAWN = 'WITHDRAWN',
}
